var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-select", {
    attrs: {
      outlined: "",
      label: "Select Domain",
      "hide-details": "",
      items: _vm.domains
    },
    model: {
      value: _vm.domain,
      callback: function callback($$v) {
        _vm.domain = $$v
      },
      expression: "domain"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }